import React, { Component } from "react";
import Chart from "react-apexcharts";
import {ApexOptions} from "apexcharts";

interface ModuleLevelProps {
    modeChartSolar: number[];
    modeChartIrr: number[];
}

interface ModuleLevelState {
    modeChartSolar: number[];
    modeChartIrr: number[];
}

const labelStyle = {
    colors: "var(--textColor)",
    fontSize: "12px",
    fontFamily: "Halvetica, sans-serif",
    fontWeight: "normal",
};

const options: ApexOptions = {
    chart: {
        type: "bar",
        stacked: false,
    },
    dataLabels: {
        enabled: false,
    },
    stroke: {
        width: [0, 0],
    },
    xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        labels: {
            style: labelStyle,
        },
    },
    yaxis: [
        {
            axisTicks: { show: false },
            axisBorder: { show: false },
            labels: {
                style: labelStyle,
                formatter: function (value: number): string {
                    return Math.round(value).toString();
                },
            },
            tooltip: { enabled: false },
            tickAmount: 5,
            min: 0,
            max: 100,
        },
    ],
    legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        offsetY: -30,
        fontSize: '12px',
    },
    fill: {
        opacity: 1,
    },
    colors: ["#5489bc", "#f8ca8d"],
};

class ModuleLevel extends Component<ModuleLevelProps, ModuleLevelState> {
    constructor(props: ModuleLevelProps) {
        super(props);
        const { modeChartSolar, modeChartIrr } = props;
        this.state = { modeChartSolar, modeChartIrr };
    }

    componentDidUpdate(prevProps: ModuleLevelProps) {
        if (
            prevProps.modeChartSolar !== this.props.modeChartSolar ||
            prevProps.modeChartIrr !== this.props.modeChartIrr
        ) {
            this.setState({
            modeChartSolar: this.props.modeChartSolar,
            modeChartIrr: this.props.modeChartIrr,
            });
        }
    }

    render() {
        const { modeChartSolar, modeChartIrr } = this.state;
        return (
            <Chart
                options={options}
                series={[
                    {
                        name: "Irradiance",
                        data: modeChartIrr,
                    },
                    {
                        name: "Solar Access",
                        data: modeChartSolar,
                    },
                ]}
                type="bar"
                width="100%"
            />
        );
    }
}

export default ModuleLevel;